import { ACCOUNT_TYPE_PASSWORD } from './constants'
import messages from './messages'

const typeMessages = {
  Normal: messages.typeNormal,
  Integration: messages.typeIntegration,
  Internal: messages.typeInternal,
}

export const getTypeLabel = (userType, formatMessage) => {
  const message = typeMessages[userType]
  return message ? formatMessage(message) : userType || '-'
}

export const getAccountType = (user) => {
  if (user.userType === 'Integration') {
    return 'Integration account'
  }
  var types = []
  if (user.aadUserId) {
    types.push('Work or school account')
  }
  if (user.lemonsoftUserId) {
    types.push('Lemonsoft account')
  }
  if (user.finvoicerEmail) {
    types.push('Finvoicer account')
  }
  if (types.length === 0) {
    return ACCOUNT_TYPE_PASSWORD
  }
  return types.join(', ')
}
